import { styled } from "@/styled-system/jsx";
import { alertWrapperBase } from "../Alerts.styled";

export const ErrorAlertWrapper = styled("div", {
  base: { ...alertWrapperBase },
});

export const ErrorIdWrapper = styled("div", {
  base: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
});
